import { Box, BoxProps, Button, ColorOptions, Icon, ModalDialogNew, Spacer, Text, TextProps } from '@jfs/ui-new'
import { SvgImage } from '../../../../comps/SvgImage'
import { Colors } from '../../../../util/util'

interface UserAddedModelProps {
  show: boolean
  onDismiss: () => void
  onPressDone: () => void
  data: any
  description: any
  title: any
}

export const ModelUserAdded = ({ show, onPressDone, data, ...props }: UserAddedModelProps) => {
  return (
    <ModalDialogNew animate={true} show={show} type="bottom" backgroundColor="TRANSPARENT">
      <Box {...styles.container}>
        <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={20}>
          <Box
            width={65}
            height={65}
            borderRadius={65}
            backgroundColor={Colors.SECONDARY as ColorOptions}
            align="center"
            justify="center">
            <SvgImage imageName={'ProfileIcon'} color="#fff" />
            <Box
              position={'absolute'}
              bottom={0}
              right={0}
              width={24}
              height={24}
              borderRadius={24}
              borderWidth={2}
              zIndex={12}
              borderColor={'#fff' as ColorOptions}
              bg={'#00B259' as ColorOptions}
              align="center"
              justify="center">
              <Icon id="STATUS_SUCCESS" color={'WHITE'} size={10} />
              {/* <SvgImage imageName="StatusSuccess" /> */}
            </Box>
          </Box>
          <Box onPress={onPressDone} testID="close" underlayColor={'TRANSPARENT'}>
            <SvgImage imageName="Close" />
          </Box>
        </Box>

        <Box direction={'column'}>
          <Spacer size={14} direction={'vertical'} />
          <Text {...styles.headerText}>{props?.title}</Text>
          <Spacer size={12} direction={'vertical'} />
          <Text {...styles.descText}>{props?.description}</Text>
        </Box>
        <Spacer size={40} direction={'vertical'} />
        <Button isFull isRound onPress={onPressDone} testID="done" height={50}>
          <Text color="WHITE" fontSize={16} fontFamily="JioType-Bold">
            Done
          </Text>
        </Button>
      </Box>
    </ModalDialogNew>
  )
}

const styles = {
  container: {
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    backgroundColor: 'WHITE',
    pb: 24,
    ph: 24,
    pt: 40,
  } as BoxProps,
  descText: {
    fontSize: 14,
    fontFamily: 'JioType-Medium',
    color: Colors.PRIMARY_GREY,
    lineHeight: 20,
  } as TextProps,
  headerText: {
    fontSize: 24,
    fontFamily: 'JioType-Black',
    color: Colors.BLACK_14,
    lineHeight: 28,
  } as TextProps,
}
